var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarPrevArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 7,
    viewBox: "0 0 4 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0438848 3.20662C0.0728545 3.13708 0.115305 3.07397 0.168789 3.02093L3.0219 0.167815C3.12935 0.060365 3.27509 0 3.42704 0C3.579 0 3.72473 0.060365 3.83218 0.167815C3.93964 0.275266 4 0.420999 4 0.572957C4 0.724915 3.93964 0.870649 3.83218 0.978099L1.37851 3.42607L3.83218 5.87404C3.93964 5.98149 4 6.12722 4 6.27918C4 6.43114 3.93964 6.57687 3.83218 6.68432C3.72473 6.79177 3.579 6.85214 3.42704 6.85214C3.27509 6.85214 3.12935 6.79177 3.0219 6.68432L0.168789 3.83121C0.115305 3.77816 0.0728545 3.71505 0.0438848 3.64552C0.014915 3.57598 0 3.5014 0 3.42607C0 3.35074 0.014915 3.27616 0.0438848 3.20662Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPrevArrow);
export default __webpack_public_path__ + "static/media/calendar-prev-arrow.8e1740f8484762d99472456a04d647de.svg";
export { ForwardRef as ReactComponent };